import { FC } from "react";

import styles from "./PACreateDraftSuccessPage.module.scss";
import CaseDraftSuccess from "@/components/PACreateForm/CaseDraftSuccess";


export const PACreateDraftSuccessPage: FC = () => {

  return (
    <div className={styles.PACreateFormContainer}>
      <CaseDraftSuccess />
    </div>
  );
};

export default PACreateDraftSuccessPage;
